import * as Sentry from '@sentry/browser'
import moment from 'moment'
import posthog from 'posthog-js'
import { initialize } from 'react-ga'

import { gaTrackingId } from './constants'
import { setupFirebase } from './services/firebase'
import { injectLocalAuth } from './utils/devAuth'
import { identifyFromStoredIdentity } from './utils/identify'

const { REACT_APP_API_ENV } = process.env

Sentry.init({
  dsn: 'https://fd35933272194285990bb729fdda03d2:103cbcf731c74269b10455c69c404453@sentry.io/2717568',
  environment: REACT_APP_API_ENV
})

// initial setup firebase
setupFirebase(REACT_APP_API_ENV)

moment.updateLocale('pt-br', require('moment/locale/pt-br'))

initialize({
  trackingId: gaTrackingId,
  useExistingGa: true,
  debug: false
})

posthog.init('phc_EXe3bbtdh67e5bxpKher6AruQsQ9ML6B7hyMtkN83MB', {
  api_host: 'https://us.i.posthog.com'
})

// DEV ONLY: injeta TOKEN e user_id no localStorage antes da app iniciar (no-op em produção)
injectLocalAuth()

identifyFromStoredIdentity()
